import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.css';

export interface SolutionCardProps {
  variant: 'flagship' | 'cashout' | 'shop' | 'bulk';
  tag: string;
  title: string;
  description: React.ReactNode;
  bullets: React.ReactNode[];
}

const SolutionCard: React.FC<SolutionCardProps> = ({
  variant,
  tag,
  title,
  description,
  bullets
}) => (
  <article
    className={classNames(styles.card, styles[variant])}
    data-variant={variant}
  >
    <span className={styles.tag}>{tag}</span>
    <h3 className={styles.heading}>{title}</h3>
    <p className={styles.desc}>{description}</p>

    <ul className={styles.bullets}>
      {bullets.map((bullet, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={`${variant}-bullet-${idx}`}>{bullet}</li>
      ))}
    </ul>
  </article>
);

export default SolutionCard;
